import { render } from "./index.vue?vue&type=template&id=7cbf35ef"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7cbf35ef&lang=less"
script.render = render

export default script